import LoginConfirmation from 'modules/auth/confirmation';
import AuthWrapper from '../authWrapper';

const ConfirmationPage = () => {
  return (
    <AuthWrapper>
      <LoginConfirmation />
    </AuthWrapper>
  );
};

export default ConfirmationPage;
